<script setup lang="ts">
import { ref, Ref, toRefs } from 'vue';
import InputSwitch from 'primevue/inputswitch';
import GoalsSlider from './GoalsSlider.vue';
import { GoalMeasurementsInterface } from '@/types';
import { EMIT } from '@/enum';

interface PropsInterface {
  goal: GoalMeasurementsInterface;
  attendeeId: number;
}

const emit = defineEmits<{
  (eventName: EMIT.SHOULD_SAVE_GOALS, showPercentGoals: boolean, goalId: number, attendeeId: number): void;
}>();

const props = defineProps<PropsInterface>();

const { goal, attendeeId } = toRefs(props);

const showPercentGoals: Ref<boolean> = ref(goal.value.show_goal);

const updateShouldSaveGoals = () => {
  emit(EMIT.SHOULD_SAVE_GOALS, showPercentGoals.value, goal.value.treatment_goal_id, attendeeId.value);
};
</script>

<template>
  <div class="flex flex-column goal-card p-3 mt-3" :class="{ disabled: !showPercentGoals }">
    <div class="w-full flex flex-row justify-content-between align-items-center">
      <div class="description mr-2">
        <b>{{ goal.description }}</b>
      </div>
      <div>
        <InputSwitch
          v-model="showPercentGoals"
          class="mt-1"
          :disabled="!!goal.completed_at"
          @change="updateShouldSaveGoals"
        />
      </div>
    </div>
    <template v-if="showPercentGoals">
      <GoalsSlider :goal="goal" :attendee-id="attendeeId" />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.disabled.goal-card {
  background: white;
  border: 2px solid $grayLight;
}
.description {
  font-size: 14px;
  line-height: 18px;
}
</style>
